import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Section } from '@nusign/picflow-backend-types';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { PICFLOW_ANALYTICS } from '../../../picflow-analytics';
import { OnGetData } from '../../../services/dialog.service';
import { SectionService } from '../../../services/section.service';
import { RadioComponent } from '../../../shared-extra/components/radio/radio.component';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-delete-asset-section-dialog',
  templateUrl: './delete-asset-section-dialog.component.html',
  styleUrl: './delete-asset-section-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, ButtonDirective, LoadingIndicatorComponent, RadioComponent],
})
export class DeleteAssetSectionDialogComponent implements OnGetData {
  private analytics = inject(PICFLOW_ANALYTICS);
  private sectionService = inject(SectionService);
  dialogName = 'delete-asset-section';
  close: (...args) => void;
  section = signal<Section>(undefined);
  assetCount = signal<number>(undefined);
  confirmed = signal(false);
  deleting = signal(false);

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 60, spacingY: 40, hasSmallBottomPart: true };
  }

  onGetData(data: { section: Section; assetCount: number }, close: (...args) => void) {
    this.close = close;
    this.section.set(data.section);
    this.assetCount.set(data.assetCount);
  }

  confirm() {
    if (!this.confirmed()) return;
    if (this.deleting()) return;
    this.deleting.set(true);
    this.sectionService.deleteSection(this.section()).subscribe(() => {
      this.analytics.track('section_deleted', true, { object: 'asset' });
      this.close(true);
    });
  }
}
